import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, addDoc, updateDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import toast from 'react-hot-toast';

export default function Inventory() {
  const [inv, setInv] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ name:'', stock:'', unit:'kg', reorderLevel:'' });

  useEffect(()=>onSnapshot(collection(db,'inventory'),s=>setInv(s.docs.map(d=>({id:d.id,...d.data()})))),[]);

  const save = async()=>{
    if(!form.name){toast.error('Enter name');return;}
    await addDoc(collection(db,'inventory'),{ name:form.name, stock:+form.stock, unit:form.unit, reorderLevel:+form.reorderLevel, updatedAt:serverTimestamp() });
    toast.success('Added'); setModal(false); setForm({name:'',stock:'',unit:'kg',reorderLevel:''});
  };
  const updateStock = async(id,val)=>updateDoc(doc(db,'inventory',id),{stock:+val});
  const low=inv.filter(m=>m.stock<=m.reorderLevel);

  return (
    <div>
      {low.length>0 && <div style={{ background:'#FCEBEB', borderRadius:9, padding:'10px 14px', fontSize:13, color:'#A32D2D', marginBottom:14 }}>⚠ Low stock: {low.map(m=>m.name).join(', ')}</div>}
      <div className="card">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
          <div className="sec-title" style={{ marginBottom:0 }}>Raw Materials</div>
          <button className="btn btn-primary" style={{ fontSize:12, padding:'5px 12px' }} onClick={()=>setModal(true)}>+ Add Material</button>
        </div>
        <table className="table">
          <thead><tr><th>Material</th><th>Stock</th><th>Unit</th><th>Reorder at</th><th>Status</th><th>Update</th></tr></thead>
          <tbody>
            {inv.map(m=>{
              const isLow=m.stock<=m.reorderLevel;
              return (<tr key={m.id}>
                <td>{m.name}</td>
                <td><b>{+m.stock.toFixed(3)}</b></td>
                <td>{m.unit}</td>
                <td>{m.reorderLevel}</td>
                <td><span className={`tag ${isLow?'tag-red':'tag-green'}`}>{isLow?'Low':'OK'}</span></td>
                <td><input type="number" defaultValue={m.stock} onBlur={e=>updateStock(m.id,e.target.value)}
                  style={{ width:70, border:'1px solid #ddd', borderRadius:6, padding:'3px 6px', fontSize:12 }} /></td>
              </tr>);
            })}
          </tbody>
        </table>
      </div>
      {modal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Add Raw Material</h3>
            {[['name','Name','text','e.g. Mozzarella'],['stock','Current Stock','number','5'],['reorderLevel','Reorder Level','number','2']].map(([k,l,t,p])=>(
              <div className="field" key={k}><label>{l}</label>
                <input className="input" type={t} placeholder={p} value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} />
              </div>
            ))}
            <div className="field"><label>Unit</label>
              <select className="input" value={form.unit} onChange={e=>setForm(f=>({...f,unit:e.target.value}))}>
                {['kg','g','L','ml','pcs'].map(u=><option key={u}>{u}</option>)}
              </select>
            </div>
            <div style={{ display:'flex', gap:8, marginTop:8 }}>
              <button className="btn" style={{ flex:1 }} onClick={()=>setModal(false)}>Cancel</button>
              <button className="btn btn-primary" style={{ flex:1 }} onClick={save}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}